import { buildModelManager } from "../builder.js";
const DefaultOptinFormCompletionSelection = {
  __typename: true,
  id: true,
  createdAt: true,
  customerId: true,
  data: true,
  formName: true,
  isProcessed: true,
  phone: true,
  updatedAt: true
};
const modelApiIdentifier = "optinFormCompletion";
const pluralModelApiIdentifier = "optinFormCompletions";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultOptinFormCompletionSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultOptinFormCompletionSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultOptinFormCompletionSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultOptinFormCompletionSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultOptinFormCompletionSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultOptinFormCompletionSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultOptinFormCompletionSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createOptinFormCompletion",
    operationReturnType: "CreateOptinFormCompletion",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      optinFormCompletion: { required: false, type: "CreateOptinFormCompletionInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultOptinFormCompletionSelection
  },
  {
    type: "action",
    operationName: "bulkCreateOptinFormCompletions",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkCreateOptinFormCompletionsInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultOptinFormCompletionSelection
  },
  {
    type: "action",
    operationName: "updateOptinFormCompletion",
    operationReturnType: "UpdateOptinFormCompletion",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      optinFormCompletion: { required: false, type: "UpdateOptinFormCompletionInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultOptinFormCompletionSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateOptinFormCompletions",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpdateOptinFormCompletionsInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultOptinFormCompletionSelection
  },
  {
    type: "action",
    operationName: "deleteOptinFormCompletion",
    operationReturnType: "DeleteOptinFormCompletion",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteOptinFormCompletions",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertOptinFormCompletion",
    operationReturnType: "UpsertOptinFormCompletion",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      optinFormCompletion: { required: false, type: "UpsertOptinFormCompletionInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateOptinFormCompletionResult": { hasReturnType: false },
      "... on UpdateOptinFormCompletionResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultOptinFormCompletionSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertOptinFormCompletions",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpsertOptinFormCompletionsInput!]"
      }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultOptinFormCompletionSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "optinFormCompletionGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const OptinFormCompletionManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultOptinFormCompletionSelection,
  operations
);
export {
  DefaultOptinFormCompletionSelection,
  OptinFormCompletionManager
};
//# sourceMappingURL=OptinFormCompletion.js.map
